'use client';

import { createSlice } from '@reduxjs/toolkit';
import { IProductVariationsState } from '../types';

const initialState : IProductVariationsState = {
  product_variations: [],
  links: {},
  currentPage: 1,
  status: '',
};


export const productVariationsSlice = createSlice({
  name: 'productVariations',
  initialState,
  reducers: {
    changeState: (state, action) => {
      return {
        ...state, ...action.payload
      }
    }
  },
});

export const { changeState } = productVariationsSlice.actions;
export default productVariationsSlice.reducer;
